import React from 'react';
import { useTranslation } from 'react-i18next';
import { sendTrackingInfo } from '@panel/commons';
import SimpleTooltip from '@panel/commons/lib/Tooltip/SimpleTooltip';
import styled, { css } from 'styled-components';
import { select } from '@panel/commons/core/themev2';
import { getColor } from '@panel/commons/core/themev3';
import { formatNumber } from '@panel/commons/helpers/formatAmount';

const MiddleInfoRight = ({ device, posting, usedForTour, isOnline }) => {
  const { t } = useTranslation();
  const { leads, postingId, impressionsStats, viewsStats } = posting;
  const isDesktop = device === 'desktop';

  const linkToLeads = `../panel/interesados?&idAviso=${postingId}&from=aviso`;

  const getPlaceholder = data => {
    if (!isOnline) return '-';
    return formatNumber(data) || 0;
  };

  const tooltipComponent = textId => {
    return <TooltipComponent device={device}>{t(`panel.avisos.posting.${textId}.tooltip`)}</TooltipComponent>;
  };

  return (
    <Container device={device} data-tour-panel={usedForTour && 'leads-info-0'}>
      {device !== 'tablet' && (
        <LeadsInfo>
          <InfoLabel>
            <SimpleTooltip
              offset={12}
              backgroundColor={select('black')}
              isMobile={device === 'tablet'}
              text={tooltipComponent('exposition')}
              dataPanel='info-exposition'
            >
              <p>{t('panel.avisos.posting.exposition')}</p>
            </SimpleTooltip>
          </InfoLabel>
          <InfoQuantity>{getPlaceholder(impressionsStats)}</InfoQuantity>
        </LeadsInfo>
      )}
      <LeadsInfo>
        <InfoLabel>
          {device === 'tablet' && <p>{t('panel.avisos.posting.visits')}</p>}
          {isDesktop && (
            <SimpleTooltip
              offset={12}
              backgroundColor={select('black')}
              text={tooltipComponent('visits')}
              dataPanel='info-visits'
            >
              <p>{t('panel.avisos.posting.visits')}</p>
            </SimpleTooltip>
          )}
        </InfoLabel>
        <InfoQuantity>{getPlaceholder(viewsStats)}</InfoQuantity>
      </LeadsInfo>
      <LeadsInfo>
        <InfoLabel data-panel='posting-leads' interested>
          {device === 'tablet' && <p>{t('postings.card.info.interested')}</p>}
          {isDesktop && (
            <SimpleTooltip
              offset={12}
              backgroundColor={select('black')}
              text={tooltipComponent('interested')}
              dataPanel='info-interested'
              allowPlacements='top-end'
              autoPlacements
            >
              <p>{t('postings.card.info.interested')}</p>
            </SimpleTooltip>
          )}
        </InfoLabel>
        <LinkWrapper interested>
          <InfoQuantity interested>{getPlaceholder(leads)}</InfoQuantity>
          <Interested data-panel='posting-irALeads' device={device}>
            <a
              href={linkToLeads}
              target='_blank'
              rel='noopener noreferrer'
              onClick={() => {
                sendTrackingInfo('Panel', 'Mis avisos', 'Card del aviso-Ver consultas');
              }}
              data-panel='panel-avisos-posting-linkToLeads'
            >
              {t('panel.aviso.card.leads')}
            </a>
          </Interested>
        </LinkWrapper>
      </LeadsInfo>
    </Container>
  );
};

const TooltipComponent = styled.div`
  width: ${({ device }) => (device === 'tablet' ? '150' : '235')}px;
  white-space: pre-wrap;
  padding: 8px 0;
`;

const LeadsInfo = styled.div`
  flex: 1;
  margin: 6px 0px;
  padding: 0px 18px;
  display: flex;
  box-sizing: border-box;
  flex-direction: column;
`;

const InfoLabel = styled.div`
  font-family: 'Hind';
  font-size: 12px;
  font-weight: 400;
  text-align: left;
  display: flex;
  align-items: center;
  color: ${({ interested }) => !interested && select('darkGray')};
  img {
    margin-top: 5px;
  }
  > p {
    margin-right: 5px;
  }
`;

const LinkWrapper = styled.div`
  display: flex;
  ${({ interested }) =>
    interested &&
    css`
      :hover {
        color: ${getColor('primary')};
        a {
          color: ${getColor('primary')};
        }
      }
    `}
`;

const InfoQuantity = styled.div`
  color: ${({ interested }) => !interested && select('darkGray')};
  font-family: 'Hind';
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 25px;
  position: relative;
  width: fit-content;
`;

const Container = styled.div`
  border: 1px solid ${select('grayMedium')};
  height: 60px;
  box-sizing: border-box;
  border-radius: 4px;
  display: flex;
  > div {
    border-right: 1px solid ${select('grayMedium')};
    &:last-of-type {
      border: none;
    }
  }
`;

const Interested = styled.div`
  display: flex;
  align-items: center;
  margin-left: 10px;
  > a {
    font-family: 'Hind';
    font-size: 12px;
    font-weight: 400;
    line-height: 22px;
    position: relative;
    top: 1.4px;
    cursor: pointer;
    color: black;
  }
`;

export default MiddleInfoRight;
